<template>

</template>

<script>
import websocketEventBus from "../eventBus/websocketEventBus";
import Formatter from "../components/libraries/Formatter";
import { mapState } from "vuex";
import config from "@/config";

const formatter = new Formatter();

export default {
  name: "AppLeave",
  data() {
    return {

    }
  },
  computed: {
    ...mapState({
      lastLeaveTime: state => state.app_leave.last_leave_time
    }),
    reloadTimeout() {
      return config.app_leave_for_imitation_events_minutes * 60 * 1000;
    },
  },
  methods: {
    getDatePhp() {
      return formatter.jsObjectToPhp(new Date());
    },
    handleVisibilityChange() {
      if (document.hidden) {
        this.handleWindowBlur();
        //this.$store.dispatch('setLastLeaveTime', Date.now());
      } else {
        this.handleWindowFocus();
      }
    },
    handleWindowBlur() {
      this.$store.dispatch('setLastLeaveTime', Date.now());
    },
    handleWindowFocus() {
      if (this.lastLeaveTime > 0) {
        const currentTime = Date.now();
        const timeSinceBlur = currentTime - this.lastLeaveTime;
        if (timeSinceBlur >= this.reloadTimeout) {
          websocketEventBus.saveEnroll({
            "message": "save_enroll",
            "data": {
              "date": this.getDatePhp(),
            },
          });
          websocketEventBus.updateNotifications({
            "message": "update-notifications"
          });
          websocketEventBus.updateBalance({
            "message": "update-balance"
          });
        }
        this.$store.dispatch('setLastLeaveTime', 0);
      }
    }
  },
  created() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    // window.addEventListener('blur', this.handleWindowBlur);
    // window.addEventListener('focus', this.handleWindowFocus);
  },
};
</script>
